import Swiper from "swiper/bundle";
const programSlider = document.querySelector(".testimonial-slider");
if (programSlider) {
  var swiper = new Swiper(".testimonial-slider", {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: ".fs-slider-button-next",
      prevEl: ".fs-slider-button-prev",
    },
  });
}
